"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const minValue_1 = require("./minValue");
const maxValue_1 = require("./maxValue");
const type_1 = require("./type");
const value_1 = require("./value");
const name_1 = require("./name");
const types_1 = require("../../types");
const values_1 = require("./values");
const renderValuesInput = {
    [types_1.ServiceType.ADMIN]: (0, jsx_runtime_1.jsx)(value_1.ParameterValueInput, {}),
    [types_1.ServiceType.OFFICE]: (0, jsx_runtime_1.jsx)(values_1.ParameterValuesInput, {}),
};
const ParameterInput = (props) => {
    const { parameters: _, service } = props;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsx)(name_1.ParameterNameInput, {}), (0, jsx_runtime_1.jsx)(type_1.ParameterTypeInput, {}), renderValuesInput[service], (0, jsx_runtime_1.jsx)(minValue_1.ParameterMinValueInput, {}), (0, jsx_runtime_1.jsx)(maxValue_1.ParameterMaxValueInput, {})] }));
};
exports.ParameterInput = ParameterInput;
//# sourceMappingURL=index.js.map